import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-info',
    templateUrl: './dialog-info.component.html',
    styleUrls: ['./dialog-info.component.scss'],
    standalone: false
})
export class DialogInfoComponent {
  
  constructor(
    public dialogRef: MatDialogRef<DialogInfoComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any
    ) {}
}
